var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupReward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4406_481)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 94,
    height: 94,
    rx: 8,
    fill: "#238856"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4406_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8835 84.2899L67.192 59.6808C72.5497 55.0985 75.9599 48.3045 75.9599 40.7173C75.9599 26.9501 64.7599 15.75 50.9925 15.75C37.2251 15.75 26.0251 26.9501 26.0251 40.7173C26.0251 48.3016 29.4383 55.0957 34.7931 59.6808L26.1073 84.2899C25.9075 84.8509 26.0721 85.4824 26.5215 85.8789C26.7975 86.1197 27.1442 86.2461 27.4937 86.2461C27.7169 86.2461 27.9431 86.1933 28.1517 86.0904L39.061 80.6358L45.67 85.9259C46.0665 86.2431 46.5953 86.3283 47.077 86.1638C47.5558 85.9935 47.9142 85.5939 48.0228 85.0975L50.0525 75.9624L54.0502 85.3531C54.2294 85.779 54.5966 86.0904 55.0431 86.2019C55.4837 86.3224 55.9624 86.2108 56.3208 85.9259L62.9299 80.6358L73.8391 86.0904C74.0477 86.1933 74.2709 86.2461 74.4971 86.2461C74.8467 86.2461 75.1933 86.1199 75.4694 85.8789C75.9188 85.4824 76.0803 84.8509 75.8835 84.2899ZM58.1214 61.5401L53.5715 62.5828C52.7226 62.6827 51.8648 62.7474 50.9925 62.7474C38.8436 62.7474 28.9624 52.8662 28.9624 40.7173C28.9624 28.5685 38.8436 18.6873 50.9925 18.6873C63.1413 18.6873 73.0225 28.5685 73.0225 40.7173C73.0225 50.3695 66.7778 58.5705 58.1214 61.5401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9913 24.5625C42.0823 24.5625 34.8359 31.8119 34.8359 40.7178C34.8359 49.6237 42.0823 56.8731 50.9913 56.8731C59.9002 56.8731 67.1466 49.6237 67.1466 40.7178C67.1466 31.8119 59.9002 24.5625 50.9913 24.5625ZM60.8373 35.88L49.088 47.6293C48.8001 47.9172 48.4242 48.0582 48.0482 48.0582C47.6722 48.0582 47.2963 47.9143 47.0084 47.6293L41.1336 41.7546C40.5668 41.1818 40.5668 40.2537 41.1396 39.6779C41.7123 39.1051 42.6435 39.1051 43.2163 39.6779L48.0512 44.5128L58.7607 33.8033C59.3335 33.2305 60.2647 33.2305 60.8374 33.8033C61.4101 34.3762 61.4101 35.3072 60.8373 35.88Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4406_481",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.717647 0 0 0 0 0.392157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4406_481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4406_481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4406_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.5,
    height: 70.5,
    fill: "white",
    transform: "translate(15.75 15.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupReward);
export default __webpack_public_path__ + "static/media/signup-reward.cd9d4cffb95f6bdc4aae916ebb0e0e6d.svg";
export { ForwardRef as ReactComponent };